const age = Math.floor((Date.now() - Date.parse('2007-01-14')) / 31557600000);

export { age };
